module.exports = __webpack_public_path__ + "static/img/jd6.1415fd0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/jd6.jpg
// module id = i2me
// module chunks = 1